// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__xEUtB","input":"Search_input__UcpM6","btn":"Search_btn__C_bP6"};